import React from "react";
// import { useNavigate } from "react-router-dom"; // used when Explore cards are enabled
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./Leadership.css";

const Leadership = () => {
  // const navigate = useNavigate();

  // Navigation cards and sub-pages (Board of Directors, Leadership Team, Board Committees) – kept for future use
  // const navCards = [
  //   {
  //     title: "Board of Directors",
  //     description: "Our board provides strategic oversight and governance, ensuring we uphold the highest standards of ethics and accountability.",
  //     path: "/leadership/board-of-directors",
  //     image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&q=80",
  //     imageAlt: "Board of directors in a governance meeting",
  //   },
  //   {
  //     title: "Leadership Team",
  //     description: "The executive team driving strategy, operations, and innovation across Pawansut Holdings Limited.",
  //     path: "/leadership/leadership-team",
  //     image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80",
  //     imageAlt: "Executive leadership team collaboration",
  //   },
  //   {
  //     title: "Board Committees",
  //     description: "Specialized committees for audit, risk, remuneration, and governance that support effective decision-making.",
  //     path: "/leadership/board-committees",
  //     image: "https://images.unsplash.com/photo-1552581234-26160f608093?w=600&q=80",
  //     imageAlt: "Committee members in discussion",
  //   },
  // ];

  const pillars = [
    { label: "Integrity", text: "We act with honesty and consistency in every decision." },
    { label: "Transparency", text: "Clear communication with stakeholders and regulators." },
    { label: "Excellence", text: "High standards in governance and day-to-day operations." },
  ];

  return (
    <div className="leadership-page min-h-screen bg-[#fafafa] text-[#1a1a1a]" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
      <PageBanner title="Leadership" />

      <main className="mx-auto max-w-[960px] px-6 pb-16 md:px-4 md:pb-12">
        <ScrollReveal variant="fadeUp">
        <section className="py-16 pb-12 md:py-12 md:pb-8">
          <h2 className="leadership-section-heading mb-5 font-semibold uppercase text-gray-500">
            Our approach
          </h2>
          <div className="grid grid-cols-1 gap-10 items-center lg:grid-cols-5 lg:gap-12">
            <div className="lg:col-span-3 [&>p]:mb-5 [&>p:last-child]:mb-0">
              <p className="leadership-body-text text-gray-700">
                The Company places the highest importance on strong corporate governance and has embedded this value across the organization. The Board of the Company comprises eminent professionals from diverse fields, bringing with them deep expertise and extensive experience in their respective domains.
              </p>
              <p className="leadership-body-text text-gray-700">
                The Company has established robust systems and frameworks to ensure that best practices in corporate governance are effectively implemented, continuously monitored, and periodically updated. These mechanisms are designed to meet evolving regulatory requirements and to adopt sound management and ethical business practices.
              </p>
            </div>
            <div className="relative lg:col-span-2 rounded-xl overflow-hidden shadow-lg border border-gray-100">
              <img
                src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=800&q=85"
                alt="Leadership team in a strategic discussion"
                className="w-full h-[240px] md:h-[280px] object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-black/50 to-transparent" aria-hidden />
            </div>
          </div>
        </section>
        </ScrollReveal>

        <ScrollReveal variant="fadeUp" delay={0.1}>
        <section className="border-t border-gray-200 py-10 pb-14 md:py-8 md:pb-10">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-8">
            {pillars.map((item) => (
              <div key={item.label}>
                <span className="leadership-pillar-label mb-2 block font-semibold uppercase text-gray-900">
                  {item.label}
                </span>
                <p className="leadership-pillar-text m-0 text-gray-500">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </section>
        </ScrollReveal>

        {/* Explore section – cards and navigation to Board of Directors, Leadership Team, Board Committees (commented for now)
        <section className="pt-8">
          <h2 className="leadership-section-heading mb-5 font-semibold uppercase text-gray-500">
            Explore
          </h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-6">
            {navCards.map((card) => (
              <div
                key={card.path}
                className="group flex min-h-[200px] cursor-pointer flex-col items-stretch rounded-xl border border-gray-200 bg-white overflow-hidden shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)] focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-[#1a1d21] md:min-h-0"
                onClick={() => navigate(card.path)}
                onKeyDown={(e) => e.key === "Enter" && navigate(card.path)}
                role="button"
                tabIndex={0}
              >
                <div className="relative h-40 md:h-44 flex-shrink-0 overflow-hidden bg-gray-100">
                  <img
                    src={card.image}
                    alt={card.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" aria-hidden />
                </div>
                <div className="flex flex-col items-start p-6 md:p-5 flex-1">
                  <h3 className="leadership-card-title mb-3 font-bold leading-snug text-gray-900">
                    {card.title}
                  </h3>
                  <p className="leadership-card-desc m-0 flex-1 text-gray-600">
                    {card.description}
                  </p>
                  <span className="leadership-view-details mt-5 font-semibold uppercase text-[#1a1d21] group-hover:underline">
                    View details
                  </span>
                </div>
              </div>
            ))}
          </div>
        </section>
        */}

        <ScrollReveal variant="fadeUp" delay={0.15}>
        <section className="border-t border-gray-200 pt-10 pb-8">
          <h2 className="leadership-section-heading mb-5 font-semibold uppercase text-gray-500">
            Board of Directors
          </h2>
          <p className="leadership-body-text text-gray-700 mb-6">
            The Board of Directors of the Company:
          </p>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 [&>li]:leadership-body-text">
            <li>Ram Kishore Bansal, Managing Director</li>
            <li>Ajay Kumar Jindal, CFO</li>
            <li>Nisha Ajuja, Independent Director</li>
            <li>Naresh Kumar</li>
            <li>Rajeev Ranjan</li>
            <li>Divya Kapoor, Independent Women Director</li>
          </ol>
        </section>
        </ScrollReveal>

        <ScrollReveal variant="fadeUp" delay={0.2}>
        <section className="border-t border-gray-200 pt-10 pb-8">
          <h2 className="leadership-section-heading mb-5 font-semibold uppercase text-gray-500">
            Committees of the Board
          </h2>
          <p className="leadership-body-text text-gray-700 mb-8">
            The following committees assist the Board of Directors.
          </p>

          <div className="space-y-10">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">a. Audit Committee</h3>
              <p className="leadership-body-text text-gray-700 mb-4">
                The committee is responsible for oversight of the financial reporting process of the Company, including the recommendation of the appointment, re-appointment, remuneration, and terms of engagement of the auditors of the Company, review of financial statements, monitoring of internal control systems, internal and statutory audit processes, compliance with applicable laws and regulations, and ensuring transparency, integrity, and accountability in the Company&apos;s financial and governance framework.
              </p>
              <p className="leadership-body-text text-gray-700 font-medium mb-2">The members of the Audit Committee are:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 [&>li]:leadership-body-text">
                <li>Rajeev Ranjan, Director</li>
                <li>Divya Kapoor, Independent Director</li>
                <li>Nisha Ahuja, Independent Director</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">b. Nomination and Remuneration Committee</h3>
              <p className="leadership-body-text text-gray-700 mb-4">
                The Nomination and Remuneration Committee is responsible for identifying and recommending qualified individuals for appointment as directors, independent directors, and senior management, and for formulating criteria for their qualifications, independence, performance evaluation, and remuneration. The Committee oversees Board and director performance evaluation, succession planning, and Board diversity, and recommends policies relating to remuneration to ensure alignment with performance, long-term objectives, and shareholder interests. It also reviews and approves remuneration of whole-time directors and senior management, evaluates continuation of independent directors, and acts as the Compensation Committee for administering employee share-based benefit schemes in accordance with applicable SEBI regulations.
              </p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 [&>li]:leadership-body-text">
                <li>Naresh Kumar, Director</li>
                <li>Divya Kapoor, Independent Director</li>
                <li>Nisha Ahuja, Independent Director</li>
              </ul>
            </div>
          </div>
        </section>
        </ScrollReveal>
      </main>
    </div>
  );
};

export default Leadership;
